<div class="forgot-password">
  @switch (recovery.requestState()) {
    @case ('idle') {
      <button
        type="button"
        class="link"
        [disabled]="recovery.cooldown.remaining('recoveryRequest') > 0"
        (click)="request()">
        {{ 'Forgot password?' | translate }}
      </button>
    }
    @case ('sending') {
      <span class="muted">{{ 'Sending recovery e-mail…' | translate }}</span>
    }
    @case ('sent') {
      <andor-notice
        variant="success"
        [dismissible]="true"
        (dismissed)="recovery.resetRequestState()">
        {{
          'An e-mail with a sign-in link was sent to the registered contact address. The link is valid for 30 minutes.'
            | translate
        }}
      </andor-notice>
    }
    @case ('sandbox') {
      <andor-notice
        variant="warning"
        [dismissible]="true"
        (dismissed)="recovery.resetRequestState()">
        {{
          'The mail service is in sandbox mode, so no e-mail was delivered. Please ask your administrator.'
            | translate
        }}
      </andor-notice>
    }
    @case ('rate-limited') {
      <andor-notice
        variant="warning"
        [dismissible]="retrySeconds() === 0"
        (dismissed)="recovery.resetRequestState()">
        @if (retrySeconds() === 0) {
          <button type="button" class="link" (click)="request()">
            {{ 'Try again' | translate }}
          </button>
        } @else if (retryInMinutes()) {
          {{
            'Too many recovery requests — please try again in [minutes] minutes.'
              | translate: { minutes: retryMinutes() }
          }}
        } @else {
          {{
            'Too many recovery requests — please try again in [seconds] seconds.'
              | translate: { seconds: retrySeconds() }
          }}
        }
      </andor-notice>
    }
    @case ('unavailable') {
      <andor-notice variant="info" [dismissible]="true" (dismissed)="recovery.resetRequestState()">
        {{
          'Password recovery is not set up for this app. Please ask your administrator to reset the team password.'
            | translate
        }}
      </andor-notice>
    }
    @case ('error') {
      <andor-notice variant="error" [dismissible]="true" (dismissed)="recovery.resetRequestState()">
        {{ "The recovery e-mail couldn't be sent. Please try again later." | translate }}
      </andor-notice>
    }
  }
</div>
